import styled, { css } from 'styled-components';

import { media } from 'utils/detection';
import Img from 'components/Img';

export default styled(Img)`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  background: none;
  object-fit: contain;
  height: auto;


  ${props =>
    props.orientation === 'portrait' &&
    css`
      height: 400px;
    `}

  ${media.medium`
    ${props =>
      props.orientation === 'portrait' &&
      css`
        height: 50vw;
      `}

    ${props =>
      props.big &&
      css`
        height: 60vh;
        width: 40vw;
        margin: 0 auto;
      `}
  `}
`;
